import { render, staticRenderFns } from "./GameReport.vue?vue&type=template&id=00c6ebb6&scoped=true&"
import script from "./GameReport.vue?vue&type=script&lang=js&"
export * from "./GameReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6ebb6",
  null
  
)

export default component.exports